import React, { useState } from 'react';
import {
  Button,
  Grid,
  DialogContent,
  TextField,
  Dialog,
  DialogTitle,
  DialogActions,
  Typography
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useStripe, useElements, CardElement } from '@stripe/react-stripe-js';
import CardSection from './CardSection';

const CardModal = ({
  setupIntent,
  isMobile,
  open,
  onClose,
  onResult,
  isModal
}) => {
  const { t } = useTranslation();
  const stripe = useStripe();
  const elements = useElements();

  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [processing, setProcessing] = useState(false);

  const handleSubmit = async event => {
    event.preventDefault();
    if (!stripe || !elements || processing) return;

    setProcessing(true);
    const cardElement = elements.getElement(CardElement);

    try {
      const result = await stripe.confirmCardSetup(setupIntent.client_secret, {
        payment_method: {
          card: cardElement,
          billing_details: {
            name: `${lastName} ${firstName}`.trim()
          }
        }
      });

      onResult(result);
    } catch (error) {
      onResult({ error });
    } finally {
      setProcessing(false);
    }
  };

  const renderStripeForm = () => (
    <form onSubmit={handleSubmit} noValidate>
      <Grid container spacing={2} className="billing-details">
        <Grid item xs={6}>
          <TextField
            name="firstName"
            label={t('account:firstName')}
            variant="outlined"
            onChange={e => setFirstName(e.target.value)}
            margin="none"
            fullWidth
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            name="lastName"
            label={t('account:lastName')}
            variant="outlined"
            onChange={e => setLastName(e.target.value)}
            margin="none"
            fullWidth
          />
        </Grid>
      </Grid>

      <br />

      <CardSection isMobile={isMobile} />

      <DialogActions>
        <Button
          type="submit"
          variant="contained"
          color="primary"
          disabled={processing}
        >
          {t('common:confirm')}
        </Button>
        {isModal && (
          <Button
            variant="outlined"
            color="primary"
            onClick={onClose}
            disabled={processing}
          >
            {t('common:cancel')}
          </Button>
        )}
      </DialogActions>
    </form>
  );

  if (isModal) {
    return (
      <Dialog
        fullWidth
        fullScreen={isMobile}
        maxWidth="xs"
        open={open}
        scroll="paper"
        onClose={onClose}
        aria-labelledby="card-modal-title"
      >
        <DialogTitle id="card-modal-title">
          {t('payment_method:add-payment-methods')}
        </DialogTitle>
        <DialogContent>{renderStripeForm()}</DialogContent>
      </Dialog>
    );
  }

  return (
    <div className="card-modal">
      <Typography variant="h6" component="h1">
        {t('payment_method:payment-methods')}
      </Typography>
      {renderStripeForm()}
    </div>
  );
};

export default CardModal;
